import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { isCustomerUser } from '@/integrations/supabase/session';

const Index = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  // Password recovery: if user landed on / with recovery hash (e.g. email link had redirect_to=origin only), send to reset page
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('type=recovery')) {
      navigate(`/reset-password${hash}`, { replace: true });
      return;
    }
  }, [navigate]);

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        navigate(isCustomerUser(user) ? '/portal' : '/dashboard');
      } else {
        navigate('/auth');
      }
    }
  }, [user, isLoading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <p className="text-xl text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
};

export default Index;
